<template>
     <div class="main-content" id="panel">
      <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: "bid-side",
  components: {
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  mounted() {
   
  }
};
</script>